import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { reduxForm, change } from "redux-form";
import { saveProfile } from "../actions/accountActions";
import Alert from "../components/Alert";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import UserInfoFields from "../components/UserInfoFields";
import { withTranslation } from 'react-i18next';

class MyProfileForm extends Component {
    

    updateProfileHandler(values) {
        this.setState({ isSavingProfile: true });
        const { user } = this.props;
        values.representative = user.representative;
        values.locale = user.locale;
      return this.props.saveProfile(values).then((response) => {
          //  console.log(response)
        }, (error) => {
        });
    }

    onGoogleAddressChange(mappedAddress) {

        this.props.change("editProfile", "address1", mappedAddress.address1);
        this.props.change("editProfile", "address2", mappedAddress.address2);
        this.props.change("editProfile", "address3", mappedAddress.address3);
        this.props.change("editProfile", "address4", mappedAddress.address4);
        this.props.change("editProfile", "postCode", mappedAddress.postCode);
        this.props.change("editProfile", "lat", mappedAddress.lat);
        this.props.change("editProfile", "long", mappedAddress.lng);
    }


    render() {
        const { t, handleSubmit, user, settings, submitting } = this.props;
        if (user.isAuthenticated  !== true){
            return <Redirect to={settings.baseUrl} />;``
        }

        const profileSavedMessage = (user.isProfileSaved) ?
            <Alert type="success" title={t("Profile")} msg={t("Your profile has been saved successfully.")} />
                                                            : "";
        return (
            <Fragment>
                {profileSavedMessage}
            <form
                className="row"
                method="post"
                onSubmit={handleSubmit(this.updateProfileHandler.bind(this))}
                >
                    <UserInfoFields settings={settings} isProfile={true} onGoogleAddressChange={this.onGoogleAddressChange.bind(this)} allowPasswordAutoComplete={true}/>
                <div className="col-12 text-center text-sm-right">
                        <button className="btn btn-primary margin-bottom-none" type="submit" disabled={submitting}>{t("Save")}</button>
                </div>
                </form>
            </Fragment>
        );
    }
}

function validate(values, props ) {
    const errors = {};
    const { t } = props;
    if (values.password !== values.confirmPassword) {
        errors.password = t("your password and confirm password doesn't match");
        errors.confirmPassword = " ";
    }
    return errors;
}

function mapStateToProps({ user, settings, orders }, ownProps) {
    var userInfo = { ...user };
    var newState = { user, settings, orders, initialValues: userInfo, ...ownProps };
    return newState;
}

MyProfileForm = connect(mapStateToProps, { saveProfile: saveProfile, change })(MyProfileForm)
// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
MyProfileForm = withRouter(reduxForm({
    form: 'editProfile',  // a unique identifier for this form
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate
})(MyProfileForm))

// You have to connect() to any reducers that you wish to connect to yourself
MyProfileForm = connect(mapStateToProps, { saveProfile: saveProfile, change })(MyProfileForm)
// We use connect twice as there is unknown issue 
// - First one is to allow loading initial values
// - Second one is to allow calling Change on a field without being overwritten by initial value
export default withTranslation()(MyProfileForm);




